import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const NewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editNewApplications.role,
    permissionsConfig.editNewApplications.action,
    permissionsConfig.editNewApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteNewApplications.role,
    permissionsConfig.deleteNewApplications.action,
    permissionsConfig.deleteNewApplications.type
  );

  return (
    <StatusApplication appStatus="8" title="New" subTitle="New" application_type="0" pageFrom="new-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default NewApplications